import MemberGate from "@/components/feature/MemberGate";
import SubmitBannerNavbar from "./components/SubmitBannerNavbar";
import SubmitBannerForm from "./components/SubmitBannerForm";

export default function SubmitBanner() {
  return (
    <div className="min-h-screen bg-beige">
      <SubmitBannerNavbar />
      <div className="pt-24 pb-16 md:pt-32 md:pb-24">
        <MemberGate>
          <SubmitBannerForm />
        </MemberGate>
      </div>
    </div>
  );
}